export default "__VITE_ASSET__CGHQfsK3__"